
import { connect } from 'react-redux';

import { withRouter } from 'react-router-dom';

import { login, signup, logout } from '../../actions/session_actions';

import { forgotPassword } from '../../actions/user_actions';

import Sidebar from './sidebar';

const mapStateToProps = (state, ownProps) => {

  const loggedIn = Boolean(state.session.currentUser)

  let currentUser = loggedIn ? state.session.currentUser : null;

  let AllPath = state.entities.AllPath;

  return {
    currentUser,
    loggedIn,
    AllPath,
  };
};

const mapDispatchToProps = dispatch => ({
  logout: () => dispatch(logout()),
  signup: user => dispatch(signup(user)),
  login: user => dispatch(login(user)),
  forgotPassword: data => dispatch(forgotPassword(data)),
  ChooseLanguage: data => dispatch({type: 'CHOOSE_A_LANGUAGE', data}),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Sidebar));
